<p>proposal-details works!</p>
